import TabellaMovimentiCertificatoView from "./TabellaMovimentiCertificatoView";
import {useContext, useEffect, useState} from "react";
import {getMovimentiApi} from "../../../../../../services/MovimentiServices";
import {LoaderContext} from "../../../../../../context/LoaderContext";
import {RuoliContext} from "../../../../../../context/RuoliContext";

export default function TabellaMovimentiCertificatoController({
                                                                  certificato,
                                                              }) {

    const [movimenti, setMovimenti] = useState([]);

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {isRuoloCommissario} = useContext(RuoliContext);

    async function getMovimenti(idCertificato) {
        startChiamata();

        const response = await getMovimentiApi({
            id_certificato: idCertificato
        });
        setMovimenti(response.data.data);
        endChiamata();
    }

    useEffect(() => {
        if (certificato && !isRuoloCommissario()) {
            getMovimenti(certificato.id_certificato);
        }
    }, [certificato]);

    return (
        <TabellaMovimentiCertificatoView
            movimenti={movimenti}
        />
    );

}